/**
 * Infinite Scroll + Scroll Restoration — tema Impulse 7.x
 * Incarcare automata a paginilor de colectie + revenire instanta la Back.
 * Dezinstalare: sterge fisierul si linia de include din theme.liquid.
 */
(function () {
  'use strict';

  var CONFIG = {
    ajaxResultSelector: '#CollectionAjaxResult, #CollectionAjaxContent',
    gridSelectors: [
      '#CollectionAjaxContent .grid--uniform',
      '.collection-grid .grid--uniform',
      '.grid--uniform'
    ],
    itemSelector: '.grid__item.grid-product, .grid-product',
    paginationSelector: '.pagination',
    prefetchMargin: '300px',
    loadDelay: 300,
    maxRestorePages: 20,
    stateTTL: 30 * 60 * 1000,
    storagePrefix: 'impulse-iscroll:',
    text: {
      loading: 'Se încarcă mai multe bijuterii pentru tine…',
      restoring: 'Se restaurează poziția…',
      end: 'Toate bijuteriile din categorie au fost încărcate',
      error: 'Nu s-au putut încărca mai multe produse.'
    }
  };

  var state = {
    page: 1,
    loading: false,
    finished: false,
    observer: null,
    rerenderObserver: null,
    sentinel: null,
    statusEl: null,
    lastClickedHref: null
  };

  function getGrid(doc) {
    doc = doc || document;
    for (var i = 0; i < CONFIG.gridSelectors.length; i++) {
      var el = doc.querySelector(CONFIG.gridSelectors[i]);
      if (el) return el;
    }
    return null;
  }

  function getPageFromUrl() {
    var p = parseInt(new URLSearchParams(location.search).get('page'), 10);
    return p > 0 ? p : 1;
  }

  function buildPageUrl(page) {
    var url = new URL(location.href);
    url.searchParams.set('page', String(page));
    return url.toString();
  }

  // Cheie unica per colectie + filtre/sortare (fara parametrul "page").
  function storageKey() {
    var params = new URLSearchParams(location.search);
    params.delete('page');
    params.sort();
    return CONFIG.storagePrefix + location.pathname + '?' + params.toString();
  }

  function readSavedState() {
    try {
      var raw = sessionStorage.getItem(storageKey());
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - data.ts > CONFIG.stateTTL) {
        clearSavedState();
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function saveState() {
    var grid = getGrid();
    var html = grid && state.page > 1 ? grid.innerHTML : '';
    var base = {
      pages: state.page,
      scrollY: window.scrollY,
      clickedHref: state.lastClickedHref,
      ts: Date.now()
    };
    try {
      base.html = html;
      sessionStorage.setItem(storageKey(), JSON.stringify(base));
    } catch (e) {
      // HTML prea mare pentru storage: salvam fara el (fallback la fetch).
      try {
        delete base.html;
        sessionStorage.setItem(storageKey(), JSON.stringify(base));
      } catch (e2) { /* storage indisponibil */ }
    }
  }

  function clearSavedState() {
    try { sessionStorage.removeItem(storageKey()); } catch (e) { /* noop */ }
  }

  function navigationType() {
    var entries = performance.getEntriesByType
      ? performance.getEntriesByType('navigation')
      : [];
    return entries.length ? entries[0].type : 'navigate';
  }

  function setStatus(text) {
    if (state.statusEl) state.statusEl.textContent = text || '';
  }

  function revealPage() {
    document.documentElement.classList.remove('iscroll-restoring');
  }

  // Dezactiveaza animatiile pe durata restaurarii SI inca 1,5s dupa afisare,
  // ca imaginile care se incarca tarziu sa apara direct, fara fade-in.
  function suppressAnimations() {
    var style = document.createElement('style');
    style.textContent =
      'html.iscroll-restoring *,html.iscroll-noanim *{animation:none!important;transition:none!important}';
    document.head.appendChild(style);
    document.documentElement.classList.add('iscroll-noanim');
    setTimeout(function () {
      document.documentElement.classList.remove('iscroll-noanim');
    }, 1500);
  }

  // Asteapta (maximum `timeout` ms) incarcarea imaginilor efectiv vizibile
  // (vertical SI orizontal — slide-urile secundare ascunse lateral nu conteaza).
  function waitForVisibleImages(timeout) {
    var imgs = [];
    var vh = window.innerHeight;
    var vw = window.innerWidth;
    document.querySelectorAll('img').forEach(function (img) {
      if (img.closest && img.closest('.grid-swipe__slide--second')) return;
      var r = img.getBoundingClientRect();
      var inVertical = r.bottom > -vh && r.top < vh * 2;
      var inHorizontal = r.right > 0 && r.left < vw;
      if (inVertical && inHorizontal && !img.complete) {
        imgs.push(img);
      }
    });
    if (!imgs.length) return Promise.resolve();

    var loaded = imgs.map(function (img) {
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    });
    var timer = new Promise(function (resolve) {
      setTimeout(resolve, timeout);
    });
    return Promise.race([Promise.all(loaded), timer]);
  }

  // Reinitializeaza componentele temei pe produsele adaugate dinamic.
  function reinitNewItems(container) {
    try {
      if (window.theme) {
        if (typeof window.theme.reinitProductGridItem === 'function') {
          window.theme.reinitProductGridItem(container);
        }
        if (typeof window.theme.initQuickShop === 'function') {
          window.theme.initQuickShop();
        }
      }
      if (window.lazySizes && window.lazySizes.loader) {
        container.querySelectorAll('.lazyload').forEach(function (img) {
          window.lazySizes.loader.unveil(img);
        });
      }
      document.dispatchEvent(new CustomEvent('collection:reloaded'));
    } catch (e) { /* un hook lipsa nu opreste scroll-ul */ }
  }
  // Aduce pagina ceruta si adauga produsele in grid. Returneaza nr. de produse.
  function fetchAndAppend(page) {
    return fetch(buildPageUrl(page), {
      headers: { 'X-Requested-With': 'fetch' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = getGrid(doc);
        var items = newGrid
          ? newGrid.querySelectorAll(CONFIG.itemSelector)
          : [];
        if (!items.length) return 0;

        var grid = getGrid();
        if (!grid) return 0;

        var fragment = document.createDocumentFragment();
        items.forEach(function (item) {
          fragment.appendChild(document.importNode(item, true));
        });
        grid.appendChild(fragment);
        reinitNewItems(grid);
        return items.length;
      });
  }

  function loadNextPage() {
    if (state.loading || state.finished) return;
    state.loading = true;
    setStatus(CONFIG.text.loading);

    var nextPage = state.page + 1;

    setTimeout(function () {
      fetchAndAppend(nextPage)
        .then(function (count) {
          if (count > 0) {
            state.page = nextPage;
            setStatus('');
          } else {
            finish(CONFIG.text.end);
          }
        })
        .catch(function () {
          finish(CONFIG.text.error);
        })
        .then(function () {
          state.loading = false;
        });
    }, CONFIG.loadDelay);
  }

  function finish(message) {
    state.finished = true;
    setStatus(state.page > 1 || message === CONFIG.text.error ? message : '');
    if (state.observer && state.sentinel) {
      state.observer.unobserve(state.sentinel);
    }
  }

  function restoreSession(saved) {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // 1) Restaurare INSTANT din cache local — zero cereri de retea.
    if (saved.html) {
      var grid = getGrid();
      if (grid) {
        suppressAnimations();
        grid.innerHTML = saved.html;
        state.page = saved.pages;
        grid.querySelectorAll('.grid-swipe-dots').forEach(function (dots) {
          if (dots.children.length >= 2) {
            dots.children[0].classList.add('is-active');
            dots.children[1].classList.remove('is-active');
          }
        });
        reinitNewItems(grid);
        restoreScrollPosition(saved, true);
        // Tinem pagina ascunsa pana cand imaginile din zona vizibila sunt
        // gata (max 1200ms), apoi o afisam dintr-o bucata, fixata pe pozitie.
        return waitForVisibleImages(1200).then(function () {
          restoreScrollPosition(saved, true);

        });
      }
    }

    // 2) Fallback (cache lipsa/prea mare): reconstruim paginile prin fetch.
    var targetPages = Math.min(saved.pages, CONFIG.maxRestorePages);
    if (targetPages <= state.page) {
      restoreScrollPosition(saved, true);

      return Promise.resolve();
    }

    state.loading = true;
    setStatus(CONFIG.text.restoring);

    var chain = Promise.resolve();
    var stopped = false;
    var loop = function (page) {
      chain = chain.then(function () {
        if (stopped) return;
        return fetchAndAppend(page).then(function (count) {
          if (count > 0) {
            state.page = page;
          } else {
            stopped = true;
            state.finished = true;
          }
        });
      });
    };
    for (var p = state.page + 1; p <= targetPages; p++) loop(p);

    return chain
      .catch(function () { /* restaurare partiala > nimic */ })
      .then(function () {
        restoreScrollPosition(saved);
        setStatus(state.finished ? CONFIG.text.end : '');
        state.loading = false;

      });
  }

function restoreScrollPosition(saved, preferExact) {
    // La restaurarea din cache local, layout-ul e identic cu cel de la
    // plecare, deci pozitia exacta in pixeli e sigura si te lasa fix
    // unde erai (nu centrat pe produs).
    if (preferExact && typeof saved.scrollY === 'number') {
      window.scrollTo({ top: saved.scrollY, behavior: 'instant' });
      return;
    }
    // Rezerva (reconstructie prin fetch): ancorarea pe produsul accesat
    // e mai robusta, pentru ca inaltimile pot diferi usor.
    if (saved.clickedHref) {
      var anchor = findProductAnchor(saved.clickedHref);
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'instant', block: 'center' });
        return;
      }
    }
    if (typeof saved.scrollY === 'number') {
      window.scrollTo({ top: saved.scrollY, behavior: 'instant' });
    }
  }

  function findProductAnchor(href) {
    var grid = getGrid();
    if (!grid) return null;
    var path = href.split('?')[0];
    var anchors = grid.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      if (anchors[i].href.split('?')[0] === path) return anchors[i];
    }
    return null;
  }

  function bindStatePersistence() {
    // Retinem ultimul produs accesat, pentru pozitionare exacta la Back.
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href*="/products/"]');
      if (link && getGrid() && getGrid().contains(link)) {
        state.lastClickedHref = link.href;
      }
    }, true);

    // pagehide acopera orice parasire a paginii si nu blocheaza bfcache.
    window.addEventListener('pagehide', function () {
      if (state.page > 1 || window.scrollY > 0) {
        saveState();
      }
    });
  }

  function setup() {
    var grid = getGrid();
    if (!grid) return false; // nu e pagina de colectie cu grid

    state.page = getPageFromUrl();
    state.loading = false;
    state.finished = false;
    state.lastClickedHref = null;

    document.querySelectorAll(CONFIG.paginationSelector).forEach(function (el) {
      el.style.display = 'none';
    });

    document
      .querySelectorAll('[data-iscroll-sentinel], [data-iscroll-status]')
      .forEach(function (el) { el.remove(); });

    state.sentinel = document.createElement('div');
    state.sentinel.setAttribute('data-iscroll-sentinel', '');

    state.statusEl = document.createElement('div');
    state.statusEl.setAttribute('data-iscroll-status', '');
    state.statusEl.setAttribute('aria-live', 'polite');
    state.statusEl.style.cssText =
      'text-align:center;padding:30px 0;width:100%;clear:both;opacity:.7;';

    grid.insertAdjacentElement('afterend', state.sentinel);
    state.sentinel.insertAdjacentElement('afterend', state.statusEl);

    if (state.observer) state.observer.disconnect();
    state.observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          loadNextPage();
          break;
        }
      }
    }, { rootMargin: CONFIG.prefetchMargin });
    state.observer.observe(state.sentinel);

    return true;
  }

  // Impulse inlocuieste continutul colectiei la filtrare: reluam de la zero.
  function watchAjaxRerenders() {
    var target = document.querySelector(CONFIG.ajaxResultSelector);
    if (!target || state.rerenderObserver) return;

    var debounce = null;
    state.rerenderObserver = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        if (!document.body.contains(state.sentinel)) {
          clearSavedState();
          setup();
        }
      }, 150);
    });
    state.rerenderObserver.observe(target, { childList: true, subtree: true });
  }

  function init() {
    if (!setup()) {
      revealPage();
      return;
    }

    bindStatePersistence();
    watchAjaxRerenders();

    var navType = navigationType();
    var saved = readSavedState();

    if (navType === 'back_forward' && saved) {
      restoreSession(saved).then(revealPage).catch(revealPage);
    } else {
      revealPage();
      if (navType === 'navigate' || navType === 'reload') {
        clearSavedState();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();